function getWindow() {
  return window;
}
export function recordSortDuration({
  durationMs,
  context
}) {
  var _w$__hsResources, _w$__hsResources2, _w$__hsResources2$crm;
  const w = getWindow();
  (_w$__hsResources = w.__hsResources) !== null && _w$__hsResources !== void 0 ? _w$__hsResources : w.__hsResources = {};
  (_w$__hsResources2$crm = (_w$__hsResources2 = w.__hsResources).crmSearchSortDurations) !== null && _w$__hsResources2$crm !== void 0 ? _w$__hsResources2$crm : _w$__hsResources2.crmSearchSortDurations = [];
  w.__hsResources.crmSearchSortDurations.push({
    durationMs,
    context
  });
}
function isValidMeasurement(item) {
  return item !== null && typeof item === 'object' && typeof item.durationMs === 'number' && (item.context === 'early' || item.context === 'standard');
}
export function drainSortDurations() {
  var _getWindow$__hsResour, _getWindow$__hsResour2;
  return ((_getWindow$__hsResour = (_getWindow$__hsResour2 = getWindow().__hsResources) === null || _getWindow$__hsResour2 === void 0 || (_getWindow$__hsResour2 = _getWindow$__hsResour2.crmSearchSortDurations) === null || _getWindow$__hsResour2 === void 0 ? void 0 : _getWindow$__hsResour2.splice(0)) !== null && _getWindow$__hsResour !== void 0 ? _getWindow$__hsResour : []).filter(isValidMeasurement);
}